(() => {
  'use strict';
  const openers = new WeakMap();
  function selectImage(gallery, index, focus = false) {
    const tabs = [...gallery.querySelectorAll('[data-toued-gallery-select]')];
    index = (index + tabs.length) % tabs.length;
    gallery.dataset.activeIndex = String(index);
    gallery.querySelectorAll('[data-toued-panel]').forEach((panel, i) => {
      panel.hidden = i !== index;
      if (i === index) panel.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
    });
    tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === index)));
    gallery.querySelector('[data-toued-gallery-status]').textContent = `${index + 1} / ${tabs.length} · ${tabs[index].dataset.touedLabel}`;
    if (focus) tabs[index].focus();
  }
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-toued-gallery-select]');
    if (thumbnail) selectImage(thumbnail.closest('[data-toued-gallery]'), Number(thumbnail.dataset.touedGallerySelect));
    const step = event.target.closest('[data-toued-step]');
    if (step) {
      const gallery = step.closest('[data-toued-gallery]');
      selectImage(gallery, Number(gallery.dataset.activeIndex || 0) + Number(step.dataset.touedStep));
    }
    const trigger = event.target.closest('[data-toued-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.touedOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      openers.set(dialog, trigger);
      dialog.showModal();
      document.documentElement.classList.add('toued-modal-open');
    }
    const closer = event.target.closest('[data-toued-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('dialog.toued-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('keydown', (event) => {
    const thumbnail = event.target.closest('[data-toued-gallery-select]');
    if (!thumbnail || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const current = Number(thumbnail.dataset.touedGallerySelect);
    selectImage(thumbnail.closest('[data-toued-gallery]'), event.key === 'Home' ? 0 : event.key === 'End' ? 2 : current + (event.key === 'ArrowRight' ? 1 : -1), true);
  });
  let swipe;
  document.addEventListener('pointerdown', event => {
    const panels = event.target.closest('.toued-gallery-panels');
    if (panels && event.pointerType !== 'mouse') swipe = {gallery: panels.closest('[data-toued-gallery]'), x: event.clientX, y: event.clientY};
  });
  document.addEventListener('pointerup', event => {
    if (!swipe) return;
    const {gallery, x, y} = swipe; swipe = null;
    const dx = event.clientX - x;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(event.clientY - y)) selectImage(gallery, Number(gallery.dataset.activeIndex || 0) + (dx < 0 ? 1 : -1));
  });
  document.addEventListener('pointercancel', () => { swipe = null; });
  document.addEventListener('close', (event) => {
    if (!event.target.matches('dialog.toued-dialog')) return;
    if (!document.querySelector('dialog.toued-dialog[open]')) document.documentElement.classList.remove('toued-modal-open');
    openers.get(event.target)?.focus();
  }, true);
})();
